// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../variables.css\"","mobile-threshold-width":"610px","logoutButton":"LogoutButton_logoutButton__NgXEn","draverIcon":"LogoutButton_draverIcon__1fOD8"};